import React from "react";
import { useNavigation } from "@react-navigation/native";
import tw from "twrnc";

import Callout from "@/components/settings/Callout";
import { SettingsPage } from "@/components/settings/SettingsPage";
import { roomNounText } from "@/components/globalUtils";
import { isGrouped, roomNounOf } from "@/components/rooms/rooms";
import { hasOwnTeam } from "@/components/teams/flag";
import TeamMembers from "@/components/teams/TeamMembers";
import TeamsForBusiness from "@/components/teams/TeamsForBusiness";
import { useTeamAccess } from "@/components/teams/useWorkspace";
import { useEventAuth } from "@/components/teams/useWorkspaceAuth";
import { t } from "@/localization";

// Event › People (PLAN.md §5.5): who can work on this event with their own
// sign-in: a co-host, a family member looking after the guestbook, a camera
// helper. A share covers the event and all its rooms (the server keys a
// room's people by its main event). Business accounts' events; in someone
// else's account, the role decides.
const EventPeople = ({ event }) => {
  const navigation = useNavigation();
  const team = useTeamAccess();
  const { account_type } = useEventAuth(event);
  if (!event?.slug) return null;

  if (!team.isShared && !hasOwnTeam(account_type)) {
    return (
      <SettingsPage title={t("People")}>
        <TeamsForBusiness />
      </SettingsPage>
    );
  }

  const canManage = team.can("manageTeam", event);
  const canManageAccount = team.can("manageTeam");
  const noun = roomNounText(roomNounOf(event).toLowerCase());

  return (
    <SettingsPage
      title={t("People")}
      description={
        event.title
          ? t("People who can work on “{title}” with their own sign-in.", {
              title: event.title,
            })
          : t("People who can work on this event with their own sign-in.")
      }
    >
      {isGrouped(event) && (
        <Callout tone="info" style={tw`mb-6`}>
          {t("People you invite here can work on every {noun} of this event.", {
            noun,
          })}
        </Callout>
      )}
      {!canManage ? (
        <Callout tone="info">
          {t("Only admins can see and invite the people on this event.")}
        </Callout>
      ) : (
        <TeamMembers
          key={event.room_of || event.slug}
          slug={event.room_of || event.slug}
          self={team.self}
          canManage
          onManageAccountTeam={
            canManageAccount ? () => navigation.navigate("Team") : undefined
          }
        />
      )}
    </SettingsPage>
  );
};

export default EventPeople;
